var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"cluster-summary\">\n<div class=\"row pt-12\"></div>\n<div class=\"row\">\n<div class=\"col-md-3\" ng-repeat=\"item in clusterSummaryCtrl.firstRow track by $index\">\n<div class=\"panel status panel-info\">\n<div class=\"panel-heading\">\n<h1 class=\"panel-title text-center\">{{item.value}}</h1>\n</div>\n<div class=\"panel-body text-center\">\n{{item.label}}\n</div>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-md-3\" ng-repeat=\"item in clusterSummaryCtrl.secondRow\">\n<div class=\"col-md-12\">\n<div class=\"update-nag\">\n<div class=\"update-split update-info\">{{item.value}}</div>\n<div class=\"update-text\">{{item.label}}\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>";
var id1="components/cluster-summary/cluster-summary.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/components/cluster-summary/cluster-summary.template.html
// module id = 842
// module chunks = 0